"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = RemoteProductIcon;
exports.getProductIconUrls = getProductIconUrls;
exports.getProductLegacyId = getProductLegacyId;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _reactNativeSvg = require("react-native-svg");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
var PRODUCT_ICON_CDN_BASE_URL = 'https://d2yw1pi6hq9rh4.cloudfront.net';
function getProductLegacyId(product) {
  var _product$product;
  return (product === null || product === void 0 ? void 0 : product.productLegacyId) || (product === null || product === void 0 || (_product$product = product.product) === null || _product$product === void 0 ? void 0 : _product$product.productLegacyId);
}
function getProductIconUrls(product) {
  var legacyId = getProductLegacyId(product);
  if (legacyId) {
    var encodedLegacyId = encodeURIComponent(legacyId);
    return ["".concat(PRODUCT_ICON_CDN_BASE_URL, "/").concat(encodedLegacyId, "-app.svg")];
  }
  return [];
}
function normalizeReactNativeSvgXml(svgText) {
  if (!svgText || !svgText.trim().startsWith('<')) {
    return undefined;
  }
  return svgText.replace(/<\s*Svg\b/g, '<svg').replace(/<\s*\/\s*Svg\s*>/g, '</svg>').replace(/<\s*G\b/g, '<g').replace(/<\s*\/\s*G\s*>/g, '</g>').replace(/<\s*Path\b/g, '<path').replace(/<\s*\/\s*Path\s*>/g, '</path>').replace(/<\s*Circle\b/g, '<circle').replace(/<\s*\/\s*Circle\s*>/g, '</circle>').replace(/<\s*Rect\b/g, '<rect').replace(/<\s*\/\s*Rect\s*>/g, '</rect>').replace(/<\s*Line\b/g, '<line').replace(/<\s*\/\s*Line\s*>/g, '</line>').replace(/<\s*Polyline\b/g, '<polyline').replace(/<\s*\/\s*Polyline\s*>/g, '</polyline>').replace(/<\s*Polygon\b/g, '<polygon').replace(/<\s*\/\s*Polygon\s*>/g, '</polygon>').replace(/<\s*Ellipse\b/g, '<ellipse').replace(/<\s*\/\s*Ellipse\s*>/g, '</ellipse>').replace(/<\s*Defs\b/g, '<defs').replace(/<\s*\/\s*Defs\s*>/g, '</defs>').replace(/<\s*ClipPath\b/g, '<clipPath').replace(/<\s*\/\s*ClipPath\s*>/g, '</clipPath>').replace(/<\s*LinearGradient\b/g, '<linearGradient').replace(/<\s*\/\s*LinearGradient\s*>/g, '</linearGradient>').replace(/<\s*RadialGradient\b/g, '<radialGradient').replace(/<\s*\/\s*RadialGradient\s*>/g, '</radialGradient>').replace(/<\s*Stop\b/g, '<stop').replace(/<\s*\/\s*Stop\s*>/g, '</stop>').replace(/<\s*Mask\b/g, '<mask').replace(/<\s*\/\s*Mask\s*>/g, '</mask>').replace(/<\s*Use\b/g, '<use').replace(/<\s*\/\s*Use\s*>/g, '</use>').replace(/\bstrokeWidth=/g, 'stroke-width=').replace(/\bstrokeLinecap=/g, 'stroke-linecap=').replace(/\bstrokeLinejoin=/g, 'stroke-linejoin=').replace(/\bstrokeMiterlimit=/g, 'stroke-miterlimit=').replace(/\bstrokeDasharray=/g, 'stroke-dasharray=').replace(/\bstrokeDashoffset=/g, 'stroke-dashoffset=').replace(/\bstopColor=/g, 'stop-color=').replace(/\bstopOpacity=/g, 'stop-opacity=').replace(/\bfillRule=/g, 'fill-rule=').replace(/\bclipRule=/g, 'clip-rule=').replace(/\bclipPath=/g, 'clip-path=').replace(/\bcolorInterpolationFilters=/g, 'color-interpolation-filters=').replace(/\bgradientUnits=/g, 'gradientUnits=').replace(/\bgradientTransform=/g, 'gradientTransform=').replace(/\bmaskUnits=/g, 'maskUnits=').replace(/\bmaskContentUnits=/g, 'maskContentUnits=').replace(/\bviewBox=/g, 'viewBox=');
  // Leave already-valid XML attributes like xmlns/viewBox/transform unchanged.
}
function RemoteProductIcon(props) {
  var product = props.product,
    fallback = props.fallback,
    _props$size = props.size,
    size = _props$size === void 0 ? 40 : _props$size,
    webStyle = props.webStyle;
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    iconIndex = _useState2[0],
    setIconIndex = _useState2[1];
  var _useState3 = (0, _react.useState)(undefined),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    xmlIcon = _useState4[0],
    setXmlIcon = _useState4[1];
  var iconUrls = (0, _react.useMemo)(function () {
    return getProductIconUrls(product);
  }, [product]);
  var iconUrl = iconUrls[iconIndex];
  (0, _react.useEffect)(function () {
    setIconIndex(0);
    setXmlIcon(undefined);
  }, [iconUrls]);
  (0, _react.useEffect)(function () {
    var cancelled = false;
    function loadXmlIcon() {
      return _loadXmlIcon.apply(this, arguments);
    }
    function _loadXmlIcon() {
      _loadXmlIcon = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var response, svgText, normalizedSvgXml, _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (iconUrl) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              _context.prev = 1;
              _context.next = 2;
              return fetch(iconUrl);
            case 2:
              response = _context.sent;
              _context.next = 3;
              return response.text();
            case 3:
              svgText = _context.sent;
              if (!(cancelled || !response.ok)) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              normalizedSvgXml = normalizeReactNativeSvgXml(svgText);
              if (normalizedSvgXml && normalizedSvgXml !== svgText) {
                setXmlIcon(normalizedSvgXml);
              }
              _context.next = 6;
              break;
            case 5:
              _context.prev = 5;
              _t = _context["catch"](1);
              return _context.abrupt("return", undefined);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 5]]);
      }));
      return _loadXmlIcon.apply(this, arguments);
    }
    void loadXmlIcon();
    return function () {
      cancelled = true;
    };
  }, [iconUrl]);
  if (!iconUrl) {
    return fallback || null;
  }
  function handleError() {
    setIconIndex(function (currentIndex) {
      return currentIndex + 1;
    });
  }
  if (_reactNative.Platform.OS === 'web') {
    return /*#__PURE__*/_react["default"].createElement(_reactNative.View, null, /*#__PURE__*/_react["default"].createElement("img", {
      alt: "",
      src: iconUrl,
      width: size,
      height: size,
      onError: handleError,
      style: webStyle
    }));
  }
  if (xmlIcon) {
    return /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.SvgXml, {
      xml: xmlIcon,
      width: size,
      height: size
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.SvgUri, {
    uri: iconUrl,
    width: size,
    height: size,
    onError: handleError
  });
}
RemoteProductIcon.propTypes = {
  product: _propTypes["default"].object,
  fallback: _propTypes["default"].node,
  size: _propTypes["default"].number,
  webStyle: _propTypes["default"].object
};